import { TokenKeeper } from './TokenKeeper';
import { StreamConnector } from './StreamConnector';

export function connectAuthorizedStream(authKeeper: TokenKeeper, connectStream: StreamConnector) {
    return async (url: string) => {
        const accessToken = await authKeeper.get();
        return await connectStream(url + `?access_token=${accessToken.token}`);
    };
}
